{
  "titles": {
    "appointmentDetailsHaveChanged": "Detail janji temu telah berubah",
    "appointmentScheduled": "Janji temu dijadwalkan",
    "appointmentConfirmed": "Janji temu dikonfirmasi",
    "appointmentRequested": "Janji temu diajukan",
    "missedAppointment": "Janji temu terlewat",
    "recurringAppointmentSeriesCreated": "Rangkaian janji temu berulang dibuat",
    "truckArrivedAtFacility": "Truk tiba di fasilitas",
    "appointmentIsInProgressAtFacility": "Janji temu sedang berlangsung di fasilitas",
    "appointmentRescheduled": "Janji temu dijadwalkan ulang",
    "appointmentCompleted": "Janji temu selesai",
    "appointmentCancelled": "Janji temu dibatalkan",
    "appointmentTagged": "Janji temu diberi tag",
    "assetReadyForPickup": "Aset siap diambil"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Detail janji temu telah berubah",
    "appointmentScheduled": "Janji temu dijadwalkan di {orgName} - {warehouseName}",
    "appointmentConfirmed": "Janji temu dikonfirmasi di {orgName} - {warehouseName}",
    "appointmentRequested": "Janji temu diajukan di {orgName} - {warehouseName}",
    "missedAppointment": "Janji temu terlewat di {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Rangkaian janji temu berulang telah dibuat",
    "truckArrivedAtFacility": "Truk tiba di {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Janji temu sedang berlangsung di {orgName} - {warehouseName}",
    "appointmentRescheduled": "Janji temu dijadwalkan ulang di {orgName} - {warehouseName}",
    "appointmentCompleted": "Janji temu selesai di {orgName} - {warehouseName}",
    "appointmentCancelled": "Janji temu dengan {orgName} - {warehouseName} dibatalkan",
    "appointmentTagged": "Janji temu diberi tag {tagName} - {warehouseName}",
    "assetReadyForPickup": "Siap Diambil - Kontainer {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Harap periksa lokasi, tanggal, waktu, dan semua detail di bawah ini.",
    "appointmentScheduled": "Harap periksa lokasi, tanggal, waktu, dan semua detail di bawah ini.",
    "appointmentConfirmed": "Harap periksa lokasi, tanggal, waktu, dan semua detail di bawah ini.",
    "appointmentRequested": "Harap tunggu konfirmasi dari gudang.",
    "missedAppointment": "Pengangkut tidak hadir pada janji temu.",
    "recurringAppointmentSeriesCreated": "Harap periksa detail janji temu berulang di bawah ini.",
    "truckArrivedAtFacility": "Periksa status dan detail janji temu di bawah ini.",
    "appointmentIsInProgressAtFacility": "Periksa status dan detail janji temu di bawah ini.",
    "appointmentRescheduled": "Periksa status dan detail janji temu di bawah ini.",
    "appointmentCompleted": "Periksa status dan detail janji temu di bawah ini.",
    "appointmentCancelled": "Harap periksa semua detail dan alasan pembatalan.",
    "appointmentTagged": "Harap periksa nama tag dan informasi di bawah ini.",
    "assetReadyForPickup": "Sebuah aset di fasilitas Anda siap diambil."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "Lihat Janji Temu",
    "appointmentScheduled": "Lihat Janji Temu",
    "appointmentConfirmed": "Lihat Janji Temu",
    "appointmentRequested": "Lihat Janji Temu",
    "missedAppointment": "Lihat Janji Temu",
    "recurringAppointmentSeriesCreated": "Lihat Janji Temu Asli",
    "truckArrivedAtFacility": "Lihat Janji Temu",
    "appointmentIsInProgressAtFacility": "Lihat Janji Temu",
    "appointmentRescheduled": "Lihat Janji Temu",
    "appointmentCompleted": "Lihat Janji Temu",
    "appointmentCancelled": "Lihat Janji Temu",
    "appointmentTagged": "Lihat Janji Temu",
    "assetReadyForPickup": "Lihat Janji Temu"
  },
  "descriptions": {
    "appointmentTagged": "Gunakan pengaturan Tag Janji Temu untuk mengaktifkan tag satu per satu"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Jadwalkan Pengambilan",
      "idLabel": "Nomor Konfirmasi",
      "ownedByLabel": "Dimiliki oleh:",
      "pickupScheduledForLabel": "Pengambilan dijadwalkan pada:",
      "noPickupScheduledLabel": "Belum ada janji temu pengambilan yang dijadwalkan",
      "storeLabel": "Toko",
      "openInGoogleMapsLabel": "Buka di Google Maps",
      "appointmentDetailsLabel": "Detail Janji Temu",
      "loadTypeLabel": "Jenis Muatan",
      "warehouseInstructionsLabel": "Instruksi Gudang",
      "amenitiesLabel": "Fasilitas yang tersedia",
      "ppeRequirementsLabel": "APD & persyaratan lainnya",
      "dockDoorLabel": "Pintu Dok",
      "dockInstructionsLabel": "Instruksi Dok",
      "carrierContactLabel": "Kontak Pengangkut"
    }
  }
}
